import { type FC, type ReactNode } from "react";

// Quiet bordered info panel — a low-emphasis card for short guidance text
// (e.g. a locked / empty state inside a drawer body).
export const NoticePanel: FC<{ children: ReactNode }> = ({ children }) => (
  <div className="rounded-xl border border-slate-200 bg-white p-3.5 text-xs text-slate-500">
    {children}
  </div>
);
